(function (global) {
  'use strict';
  // Locate the next calendar-day boundary in the configured IANA timezone.
  // Searching UTC instants also handles 23/25-hour daylight-saving days.
  function nextMidnight(now, timezone) {
    const formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit'
    });
    const day = formatter.format(now);
    let lo = Math.floor(now / 1000), hi = lo + 27 * 3600;
    while (hi - lo > 1) {
      const mid = Math.floor((lo + hi) / 2);
      if (formatter.format(mid * 1000) === day) lo = mid;
      else hi = mid;
    }
    return hi * 1000;
  }
  function formatRemaining(milliseconds) {
    const seconds = Math.max(0, Math.ceil(milliseconds / 1000));
    return [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60]
      .map(value => String(value).padStart(2, '0')).join(':');
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { nextMidnight, formatRemaining };
  if (!global.customElements || global.customElements.get('wellious-daily-offer')) return;
  global.customElements.define('wellious-daily-offer', class extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.digits = this.querySelector('[data-offer-digits]');
      this.timezone = this.dataset.timezone;
      this.deadline = 0;
      this.lastValue = null;
      this.onVisibility = () => { if (!document.hidden) this.tick(); };
      if (!this.digits || !this.timezone) return;
      this.digits.replaceChildren();
      this.tick();
      if (this.hidden) return;
      this.interval = global.setInterval(() => this.tick(), 1000);
      document.addEventListener('visibilitychange', this.onVisibility);
      // Redraw at once when a cart re-render empties the digits, instead of on the next second.
      if (global.MutationObserver) {
        this.observer = new global.MutationObserver(() => {
          if (!this.digits.children.length) this.tick();
        });
        this.observer.observe(this.digits, {childList: true});
      }
    }
    tick() {
      try {
        const now = Date.now();
        if (!this.deadline || now >= this.deadline || now < this.previousNow) {
          this.deadline = nextMidnight(now, this.timezone);
        }
        this.previousNow = now;
        this.renderDigits(formatRemaining(this.deadline - now));
        this.hidden = false;
      } catch (_) { this.hidden = true; this.stop(); }
    }
    renderDigits(value) {
      const reduced = global.matchMedia('(prefers-reduced-motion: reduce)').matches;
      // The cart drawer re-renders in place, keeping this element but emptying the
      // digits and restoring `hidden`, so rebuild whenever the slots are missing.
      if (this.digits.children.length !== value.length) {
        this.digits.replaceChildren();
        this.lastValue = null;
      }
      if (!this.lastValue) {
        for (const character of value) {
          const slot = document.createElement('span');
          slot.className = character === ':' ? 'daily-offer__colon' : 'daily-offer__digit';
          const face = document.createElement('span');
          face.textContent = character;
          slot.append(face);
          this.digits.append(slot);
        }
      } else {
        [...value].forEach((character, index) => {
          if (character === this.lastValue[index]) return;
          const slot = this.digits.children[index];
          const old = slot.lastElementChild;
          const next = document.createElement('span');
          next.textContent = character;
          slot.replaceChildren(old, next);
          if (reduced || document.hidden || !next.animate) {
            slot.replaceChildren(next);
            return;
          }
          const timing = {duration: 480, easing: 'cubic-bezier(.22,.75,.24,1)', fill: 'forwards'};
          old.animate([{transform: 'translateY(0)'}, {transform: 'translateY(105%)'}], timing);
          const arrival = next.animate([{transform: 'translateY(-105%)'}, {transform: 'translateY(0)'}], timing);
          arrival.onfinish = () => old.remove();
        });
      }
      this.lastValue = value;
    }
    stop() {
      global.clearInterval(this.interval);
      if (this.observer) this.observer.disconnect();
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
    }
    disconnectedCallback() { this.stop(); }
  });
})(typeof window !== 'undefined' ? window : globalThis);
